/**
 * PdpTrustInfo.js
 *
 * Handles the expanded trust info block on PDP (AB test: pdpInfoLayoutAB).
 * - Calculates arrival date estimates based on business days
 * - Switches all text between hand-painted and print variants with the chosen variant's Type
 *
 * Visibility is handled entirely by CSS using the body attribute
 * [data-pdp-info-layout-ab]. This file only manages content/text.
 */
;(() => {
  'use strict';

  function addBusinessDays(startDate, days) {
    var d = new Date(startDate);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var dow = d.getDay();
      if (dow !== 0 && dow !== 6) added++;
    }
    return d;
  }

  function formatShortDate(d) {
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return months[d.getMonth()] + ' ' + d.getDate();
  }

  // Print or hand-painted: the chosen variant's Type once it changes (variant:change), until then what the page was
  // rendered with (data-printed, snippets/product-trust-info.liquid). Not the type toggle: on a print-only design it
  // never reads "Printed", so prints got the hand-painted text and delivery times.
  var printedNow = null;

  function getIsPrinted(container) {
    return printedNow !== null ? printedNow : container.dataset.printed === 'true';
  }

  function updateContent() {
    document.querySelectorAll('[data-pdp-info-layout-element]').forEach(function (container) {
      var isPrinted = getIsPrinted(container);
      var minDays = parseInt(isPrinted ? container.dataset.printMin : container.dataset.hpMin, 10);
      var maxDays = parseInt(isPrinted ? container.dataset.printMax : container.dataset.hpMax, 10);

      // Arrival dates
      var now = new Date();
      var dateMin = addBusinessDays(now, minDays);
      var dateMax = addBusinessDays(now, maxDays);
      var dateText = 'Get it by ' + formatShortDate(dateMin) + ' \u2013 ' + formatShortDate(dateMax) + ' if you order today';

      var arrivalEl = container.querySelector('[data-trust-arrival-dates]');
      if (arrivalEl) arrivalEl.textContent = dateText;

      // Trust item text
      for (var i = 1; i <= 4; i++) {
        var item = container.querySelector('[data-trust-item="' + i + '"]');
        if (!item) continue;

        var hpTitle = container.dataset['item' + i + 'Title'] || '';
        var hpDesc = container.dataset['item' + i + 'Desc'] || '';
        var printTitle = container.dataset['item' + i + 'PrintTitle'] || '';
        var printDesc = container.dataset['item' + i + 'PrintDesc'] || '';

        var titleEl = item.querySelector('[data-trust-item-title]');
        var descEl = item.querySelector('[data-trust-item-desc]');

        if (titleEl) titleEl.textContent = isPrinted && printTitle ? printTitle : hpTitle;
        if (descEl) descEl.textContent = isPrinted && printDesc ? printDesc : hpDesc;
      }
    });
  }

  // ── Init ────────────────────────────────────────────────────

  function init() {
    updateContent();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on product rerender (variant change)
  document.addEventListener('product:rerendered', init);

  // The main product form's variant changed (native picker, master picker, the v2 tabs): its Type decides
  document.addEventListener('variant:change', function (e) {
    var form = e.target;
    var variant = e.detail && e.detail.variant;
    if (!variant || !form.getAttribute || !/^product-form-main/.test(form.getAttribute('id') || '')) return;
    var values = variant.options || [variant.option1, variant.option2, variant.option3];
    printedNow = values.some(function (value) { return /^print(ed)?$/i.test(String(value || '').trim()); });
    updateContent();
  });
})();
